// src/hooks/useChildViewMode.js
// Hook for managing child card view mode (Oceny/Dieta/Zapisy) per child
import { useState, useCallback, useEffect } from 'react';
import { logger } from '@/lib/logger';

const STORAGE_KEY_PREFIX = 'kidconnect_child_view_';

export function useChildViewMode(userId) {
  const [viewModes, setViewModes] = useState({});

  // Load from localStorage on mount
  useEffect(() => {
    if (!userId) return;

    try {
      const stored = localStorage.getItem(`${STORAGE_KEY_PREFIX}${userId}`);
      if (stored) {
        setViewModes(JSON.parse(stored));
      }
    } catch (e) {
      logger.error('Failed to load child view modes', { message: e.message });
    }
  }, [userId]);

  // Save to localStorage when viewModes change
  useEffect(() => {
    if (!userId || Object.keys(viewModes).length === 0) return;

    try {
      localStorage.setItem(`${STORAGE_KEY_PREFIX}${userId}`, JSON.stringify(viewModes));
    } catch (e) {
      logger.error('Failed to save child view modes', { message: e.message });
    }
  }, [userId, viewModes]);

  const getViewMode = useCallback((childId) => {
    return viewModes[childId] || 'oceny';
  }, [viewModes]);

  const setViewMode = useCallback((childId, mode) => {
    setViewModes(prev => ({
      ...prev,
      [childId]: mode
    }));
  }, []);

  return { getViewMode, setViewMode };
}
